<template>
    <main class="main-content main-content-contact">
        <div class="container-fluid container-contact">
            <div class="row">
                <div class="col-12">
                    <p class="contact-title"><strong>Contato</strong></p>
                </div>
            </div>
        </div>
        <div class="container container-contact-content">
            <div class="row">
                <div class="col-12 col-md-4">
                    <img class="logotype" src="@/assets/images/logo-gazetaweb.com.png" alt="">
                    <div class="contact-info-block">
                        <p class="contact-info-title"><strong>Contato Comercial</strong></p>
                        <p class="contact-info-text">(82) 4009 7755</p>
                        <p class="contact-info-text">comercialga@gazetaweb.com</p>
                    </div>
                    <div class="contact-info-block">
                        <p class="contact-info-title"><strong>Redação</strong></p>
                        <p class="contact-info-text">(82) 4009 7853</p>
                        <p class="contact-info-text">noticias@gazetaweb.com</p>
                    </div>
                </div>
                <div class="col-12 col-md-8">
                    <div class="contact-form-block">
                        <p class="contact-form-title">Fale com a Gazetaweb</p>
                        <p class="contact-form-text">Preencha o formulário abaixo</p>

                        <div class="success" v-if="result=='success'">Mensagem enviada com sucesso</div>
                        <div class="error" v-if="result=='error'">Não foi possível enviar sua mensagem.</div>
                        <form action="" ref="contactForm">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="contact-input-wrapper">
                                        <input class="contact-form-input" type="text" id="name" v-model="name" required aria-describedby="nameInput" />
                                        <label>Insira seu nome</label>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <Selector label="Selecione o assunto" v-model="subject" :options="options" />
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="contact-input-wrapper">
                                        <input class="contact-form-input" type="text" id="email" v-model="email" required aria-describedby="nameInput" />
                                        <label>Insira seu e-mail</label>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="contact-input-wrapper">
                                        <input class="contact-form-input" type="text" id="phone" v-model="phone" required aria-describedby="nameInput" />
                                        <label>Seu telefone</label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="contact-input-wrapper contact-textarea-wrapper">
                                        <textarea class="contact-form-textarea" id="message" rows="6" required v-model="message"></textarea>
                                        <label>Mensagem</label>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <vue-recaptcha 
                                        sitekey="6LfgGvAUAAAAAAoNRc3c47u9srt2i1hamTIy5KDc" 
                                        :loadRecaptchaScript="true"
                                        @verify="send">
                                        <input class="contact-submit-btn" type="submit" value="Enviar">
                                    </vue-recaptcha>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import api from '@/api'
import Selector from '@/components/Selector'

import VueRecaptcha from 'vue-recaptcha';

export default {
    name: 'Contato',
    components: {Selector, VueRecaptcha},
    head:{
        title:{
            inner: 'Contato'
        }
    },
    data(){
        return {
            name: null,
            subject: null,
            email: null,
            phone: null,
            message: null,
            result: 'success',
            options:[
                {
                    key: 'Reclamações',
                    label: 'Reclamações',
                },
                {
                    key: 'Dúvidas',
                    label: 'Dúvidas',
                },
                {
                    key: 'Editor',
                    label: 'Editor',
                },
            ]
        }
    },
    methods:{
        reset() {
            this.name = null
            this.subject = null
            this.email = null
            this.phone = null,
            this.message = null
        },
        async send() {
            
            if (this.$refs.contactForm.checkValidity()){
                let formData = new FormData()
                formData.append('name',this.name)
                formData.append('subject',this.subject)
                formData.append('email',this.email)
                formData.append('phone',this.phone)
                formData.append('message',this.message)
    
                const response = await api.post('contact/',formData)
    
                if(response.ok) {
                    this.result = response.data.result
                    if (this.result == 'success') {
                        this.reset()
                    }
                }
            } else {
                this.$refs.contactForm.reportValidity()
            }
        },
    }
}
</script>